import {RESET} from "../constants/constants";

export const reset = () => {
  return {
    type : RESET,
    payload : {}
  };
};



// WEBPACK FOOTER //
// ./src/actions/reset.js